// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"72":"4a923a37","393":"4a923a37","499":"4a923a37","517":"4a923a37","597":"4a923a37","644":"4a923a37","739":"4a923a37","802":"4a923a37","883":"4a923a37","919":"4a923a37"}[chunkId] + ".chunk.css";
};